<script>
export default {
  components: {
  },
  data () {
    return {
      salesPerson: '',
      currentDate: '',
      changeProjectLoading: false,
      icon: 'easternblue mr2 menu-icon-plans',
      introVisible: true,
      customColor: '#4DCF55',
      title: 'My Project - Title',
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      showmodal: false,
      submitted: false,
      date: '',
      projectsData: [],
      // checklistItems: checklist.data,
      checklistOptions: [],
      options: [],
      value: [],
      changeProjectVisible: false,
      event: {
        title: ''
      },
      addFilesVisible: false,
      fileList: [],
      changeProjectForm: {
        project: ''
      },
      currentProject: '',
      currentName: '',
      tagsData: [],
      tagsDataOptions: []
    }
  },
  mounted () {
    // this.options = this.projects.map(item => {
    //   return { value: `value:${item}`, label: `label:${item}` }
    // })
    /* eslint-disable no-alert, no-console */
    // console.log(this.checklistItems)
    /* eslint-enable no-alert */
    this.salesPerson = localStorage.getItem('id_token_portal')
    // this.displayTagsList()
    // this.displayApproved()
  },
  methods: {
    /* eslint-disable no-unused-vars, no-console */
    /**
     * open missing items
     */
    /**
     * change project
     */
    openProjectModal () {
      this.changeProjectVisible = true
    },
    /**
     * hide project modal
     */
    closeProjectModal () {
      this.submitted = false
      this.changeProjectVisible = false
    },
    /**
     * open files modal
     */
    openFilesModal () {
      this.addFilesVisible = true
    },
    /**
     * hide project modal
     */
    closeFilesModal () {
      this.addFilesVisible = false
    },
    /**
     * start project wizard
     */
    launchProjectWizard () {
      this.$router.push('/create-project/step=1')
    },
    /**
     * Goto timeline
     */
    seeTimeline () {
      this.$router.push('/project-timeline')
    },
    /**
     * Get date
     */
    nowDate () {
      var formattedDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/')
      this.currentDate = formattedDate
    },
    /**
     * Goto calendar
     */
    seeCalendar () {
      this.$router.push('/mycalendar')
    },
    /**
     * Hide welcome message
     */
    /**
     * add new tag to array
     */
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    /**
     * show and focus new tag input
     */
    showInput () {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.saveTagInput.focus()
      })
    },
    /**
     * Hide new tag input
     */
    hideInput () {
      this.inputVisible = false
    },
    removeEvent () {
    },

    /**
     * Modal form submit
     */
    handleSubmit () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        const title = this.event.title
        this.calendarEvents = this.calendarEvents.concat({
          id: this.calendarEvents.length + 1,
          title: title,
          start: this.date,
          backgroundColor: '#626ed4'
        })
        this.showmodal = false
        this.newEventData = {}
      }
      this.submitted = false
      this.event = {}
    },
    /**
     * File upload and filelist
     */
    addFileSubmit () {
      let newfile = this.file
      if (newfile) {
        this.fileList.push(newfile)
      }
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    redirectToOffer () {
      this.$router.push('/offer')
    },
    handleInputConfirm (type) {
      var inputValue = this.inputValue
      var tags = this.tagsData
      var tagExist = false
      if (inputValue.trim().length > 0) {
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].TAG_NAME === inputValue) {
            tagExist = true
          }
        }
        if (type === 'keyup') {
          if (!tagExist) {
            if (type === 'keyup') {
              this.addTag(inputValue)
            }
            this.inputVisible = false
            this.inputValue = ''
          } else {
            this.$message({
              type: 'error',
              message: 'Already exists'
            })
          }
        }
      } else {
        this.inputVisible = false
        this.inputValue = ''
      }
    },
    displayApproved () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(this.$http.options.root + '/partner/project/approved', { headers }, data, { emulateJSON: true }).then(
        response => {
          console.log(response)
        },
        err => {
          console.log(err)
        }
      )
    }
  }
}
</script>

<template>
  <div id="customer-projects">
    <div class="mb4"></div>
    <div class="clearfix">
      <div class="col col-12 px0">
        <div class="clearfix border shakespeare-border--light flex justify-start items-center mb1">
          <div class="col-12 flex flex-column p2 highlights">
            <div class="flex justify-start items-center pt2 pr2">
              <template>
                <div v-if="currentName">
                  <p class="h6 book battelship p0 m0">Current project</p>
                  <p class="h1 regular easternblue mr4 line-height-2">{{this.currentName}}</p>
                </div>
                <div v-else>
                  <p class="h1 regular easternblue mr4 line-height-2">No Project Selected</p>
                </div>
              </template>
              <!-- tag input setup -->
              <button @click="openProjectModal()" class="ml4 flex-none primary-button p2 line-height-1 regular mb0">Change project
                <span class="ml1"><i class="el-icon-right"></i></span>
              </button>
          </div>
        </div>
        <!-- <div class="hide px2">
          <el-select v-model="value" placeholder="Select">
            <el-option v-for="(project, index) in projectsData" :key="index" :label="project.DESCRIPTION" :value="project.DESCRIPTION"></el-option>
          </el-select>
          <button class="flex-none outlined-primary-button button-padding">Select project
            <span class="ml1"><i class="el-icon-right"></i></span>
          </button>
        </div> -->
      </div>
        <div class="clearfix flex flex-wrap">
          <!-- intro -->
          <div v-if="introVisible" class="flex flex-1 mb2 pr1 pl0" style="min-width:50%;max-width:50%;">
            <div class="col-12 flex-1 p3 highlights border shakespeare-border--light">
              <div class="flex items-center mb2">
                <img src="/static/svg/metro-warning.svg" width="40" class="mr1">
                <div class="flex">
                  <h3 class="regular cyprus m0 mr1">Deficiency List</h3>
                  <div class="white border circle red-background flex justify-center items-end" style="width:20px; height: 20px;">
                    <span class="small center">2</span>
                  </div>
                </div>
              </div>
              <h5 class="regular darkblue mt1 mb1">Addendum</h5>
              <p class="darkblue">Contract</p>
              <div class="flex mb2">
                <div class="col-7 p0 flex mr4">
                  <table class="col-12 p0">
                    <tbody>
                      <tr class="pb1">
                        <td class="darkblue pr1">Addendum 1 / Sink</td>
                        <td>
                          <el-tag
                            :key="1"
                            type="success"
                            effect="dark"
                            class="mb1">
                            Approved
                          </el-tag>
                        </td>
                      </tr>
                      <tr class="pb1">
                        <td class="darkblue pr1">Addendum 1 / Sink</td>
                        <td>
                          <el-tag
                            :key="1"
                            type="warning"
                            effect="dark"
                            class="mb1">
                            Pending
                          </el-tag>
                        </td>
                      </tr>
                      <tr class="pb1">
                        <td class="darkblue pr1">Addendum 1 / Sink</td>
                        <td>
                          <el-tag
                            :key="1"
                            type="danger"
                            effect="dark"
                            class="mb1">
                            Declined
                          </el-tag>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-4 p0">
                  <table class="col-12 p0">
                    <tbody>
                      <tr class="pb1">
                        <td class="darkblue pr1">New Bathroom</td>
                        <td class="text-right pointer">
                          <img src="/static/svg/feather-download.svg" width="15" class="mb2">
                        </td>
                      </tr>
                      <tr class="pb1">
                        <td class="darkblue pr1">Sink Repair</td>
                        <td class="text-right pointer">
                          <img src="/static/svg/feather-download.svg" width="15" class="mb2">
                        </td>
                      </tr>
                      <tr class="pb1">
                        <td class="darkblue pr1">New Tiles</td>
                        <td class="text-right pointer">
                          <img src="/static/svg/feather-download.svg" width="15" class="mb2">
                        </td>
                      </tr>
                      <tr class="pb1">
                        <td class="darkblue pr1">Lobby Facade</td>
                        <td class="text-right pointer">
                          <img src="/static/svg/feather-download.svg" width="15" class="mb2">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <button class="h5 p2 regular action-button button-padding">Addendum to contract
                <span class="ml1"><i class="h5 regular el-icon-circle-plus-outline m0"></i></span>
              </button>
            </div>
          </div>
          <!-- Finance -->
          <div class="flex flex-1 mb2" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light">
              <div class="center my2">
                <img class="mx-auto mb1" src="/static/svg/map-finance.svg" height="40">
                <h4 class="darkblue mt1">Finance</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat.</p>
            </div>
          </div>
          <!-- Wallet -->
          <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light">
              <div class="center my2">
                <img class="mx-auto mb1" src="/static/svg/wallet-new.svg" height="50">
                <h4 class="darkblue mt1">Wallet</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
          <!-- Pictures -->
          <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light">
              <div class="center my2">
                <img class="mx-auto mb1" src="/static/svg/pictures-new.svg" height="50">
                <h4 class="darkblue mt1">Pictures</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
          <!-- Project Open -->
          <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light">
              <div class="center my2">
                <h4 class="darkblue mt1">Project Open</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              <div class="col-11 mx-auto">
                <el-progress :stroke-width="7" :percentage="43" :max="100" :color="customColor"></el-progress>
              </div>
            </div>
          </div>
          <!-- Recent Project -->
          <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light">
              <div class="center my2">
                <h4 class="darkblue mt1">Recent Project</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              <div class="col-11 mx-auto">
                <el-progress :stroke-width="7" :percentage="43" :max="100" :color="customColor"></el-progress>
              </div>
            </div>
          </div>
          <!-- Project Message -->
          <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 highlights border shakespeare-border--light p2">
              <div class="center my2">
                <img class="mx-auto mb1" src="/static/svg/speech-bubble.svg" height="60">
                <h4 class="darkblue mt1">Project Message</h4>
              </div>
              <p class="col-11 mx-auto center mediumgrey">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div>
          </div>
          <!-- timeline -->
          <!-- <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div class="projectSection pointer col-12 highlights p2">
              <div class="center my2">
                <b-img :src="require('@/assets/images/svg/clock-large.svg')" height="50"></b-img>
                <h4 class="regular mt1">{{$t('week')}} 8 - {{$t('timeline')}}</h4>
              </div>
              <p class="col-11 mx-auto mediumgrey">{{$t('project_timeline_text')}}</p>
            </div>
          </div> -->
          <!-- missing items -->
          <!-- <div class="flex flex-1 mb2 px1" style="min-width:25%;max-width:25%;">
            <div @click="openMissingItemsModal()" class="projectSection pointer col-12 highlights p2">
              <div class="center my2">
                <b-img :src="require('@/assets/images/svg/checklist.svg')" height="50"></b-img>
                <h4 class="regular mt1">{{$t('incompletes')}}</h4>
              </div>
              <p class="col-11 mx-auto mediumgrey">Lorem upsum sit amet, consetetur sadipscing elitr, set diam nonumy eirmod tempor.</p>
            </div>
          </div> -->
          <div class="hide flex flex-1 mb2 px1">
            <div class="p2 py3 highlights border shakespeare-border--light">
              <div class="col-12 px0 flex justify-start items-start">
                <div @click="seeTimeline()" class="pointer flex flex-none justify-start items-center">
                  
                  <h4 class="regular mx2 my0 flex-none"></h4>
                </div>
                <div class="px2">
                  <p class="mediumgrey">Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ullam illum beatae, nam tenetur natus, autem similique illo quis possimus, maxime saepe ratione aliquid quaerat commodi sequi quisquam quidem cupiditate!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Change project -->
    <b-modal
      centered
      v-model="changeProjectVisible"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="col-12 px2 pt1 mb3">
        <div v-if="changeProjectLoading">
          <Loading></Loading>
        </div>
        <div class="col-12 p0" v-else>
          <div class="col-12 p0 flex justify-between items-center pt1 mb2">
            <p class="h5 cyprus regular line-height-1 m0 p0">Change Project</p>
            <button class="right h4 p0 primary-white-button" @click="closeProjectModal()">
              <i class="el-icon-close"></i>
            </button>
          </div>
          <el-select v-model="changeProjectForm.project" placeholder="Select" class="col-12 p0" :class="{ 'is-invalid': submitted && $v.changeProjectForm.project.$error }" no-data-text="No data">
            <el-option v-for="(project, index) in projectsData" :key="index" :label="project.DESCRIPTION" :value="project.ID"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 px2 py3 flex justify-between" v-if="!changeProjectLoading">
        <button @click="closeProjectModal()" class="h5 p2 regular primary-button">
          <span class="mr1"><i class="el-icon-back"></i></span>
          Afbryd
        </button>
        <button @click="changeProject()" class="h5 p2 regular action-button">Ok
          <span class="ml1"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </b-modal>
    <!-- add files -->
    <b-modal
      size="lg"
      centered
      v-model="addFilesVisible"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div slot="modal-header">
        <div class="col-12 px2 flex justify-between items-center pt1">
          <p class="h5 cyprus regular line-height-1 m0 p0">Add Files</p>
          <button class="right h4 p0 primary-white-button" @click="closeFilesModal()">
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>
      <div class="col-12 px2">
        <div class="clearfix">
        <el-upload @submit="addFileSubmit()" action="/" class="projectFileUpload" drag :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" multiple>
            <i class="el-icon-upload cyprus"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip h6 regular easternblue line-height-1 mt2 center" slot="tip">jpg/png files with a size less than 500kb</div>
          </el-upload>
          <div class="py1"></div>
          <div class="col-12">
            <div v-for="(file, index) in fileList" :key="index">
              {{file}}
            </div>
          </div>
          <div class="py2"></div>
          <div class="col-12 px0 flex flex-column">
            <p class="h5 easternblue regular line-height-1 m0 p0">Project files</p>
            <div class="py1"></div>
            <div class="col-6 px0 flex justify-between">
              <div>
                <p class="cyprus line-height-1">
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="el-icon-picture-outline"></i></span>
                ImageFileName.jpg</p>
              </div>
              <div>
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="green el-icon-success"></i></span>
              </div>
            </div>
            <div class="col-6 px0 flex justify-between">
              <div>
                <p class="cyprus line-height-1">
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="el-icon-document"></i></span>
                DocumentFileName.pdf</p>
              </div>
              <div>
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="green el-icon-success"></i></span>
              </div>
            </div>
            <div class="col-6 px0 flex justify-between">
              <div>
                <p class="cyprus line-height-1">
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="el-icon-data-analysis"></i></span>
                ChartFileName.xls</p>
              </div>
              <div>
                <span class="h5 mr1 mb0 p0 line-height-1"><i class="green el-icon-success"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 px2 py3 flex justify-between">
        <button @click="closeFilesModal()" class="outlined-disabled-button button-padding">
          <span class="mr1"><i class="el-icon-back"></i></span>
          Afbryd
        </button>
        <button @click="closeFilesModal()" class="action-button button-padding">Ok
          <span class="ml1"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss">
.projectSection {
  transition: all 200ms linear;
  transform: scale(1);
  &:hover {
    transform: scale(1.09);
    border-color: rgba(#19A3C0, 50%);
    background-color: white;
    z-index: 4;
  }
}
.el-input__inner::placeholder {
  color: #003645;
}
.el-input--mini:focus {
 /*  border: 1px solid rgba(0, 54, 69, 1.0); */
  color: 1px solid rgba(0, 54, 69, 1.0)!important;
}
.el-tag {
  border-radius: 0;
  height: auto;
}
.el-progress__text {
  margin-left: 12px;
  color: rgba(47, 54, 64, 0.5);
}
.checklistItems {
  .el-checkbox {
    margin-bottom: 1rem;
    color: #003645;
    font-weight: 400;
    font-size: 20px;
  }
  .el-checkbox__inner {
    width: 18px;
    height: 18px;
    border-color: #19A3C0!important;
    &::after {
      left: 6px;
      top: 3px;
    }
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #19A3C0!important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #19A3C0!important;
  }
}
.el-tag {
  border-radius: 0;
  text-transform: capitalize;
  border: 0;
  color: #fff;
  height: auto;
  background-color: rgb(25, 163, 192);
}
.el-tag .el-tag__close {
  color: #fff;
}
.el-tag .el-tag__close:hover {
  background-color: #003645;
  color: #fff;
}
.button-new-tag {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
.el-table input::-webkit-calendar-picker-indicator {
  display: none !important;
}
#my-project input::-webkit-calendar-picker-indicator {
  display: none !important;
}
#customer-projects .modal-header {
  display: block;
}
</style>


// WEBPACK FOOTER //
// CustomerProjects.vue?650c43bd